import { Chip, CircularProgress } from "@mui/material";
import "./SelectableChip.css";
import { FormSelectorChipProps } from "./SelectableChip.type";

export function SelectableChip({
  label,
  selected,
  isDeleting,
  onClick,
  onDelete,
}: FormSelectorChipProps) {
  return (
    <Chip
      className={`selectable-chip selectable-chip--${selected ? "filled" : "outlined"}`}
      label={label}
      color="secondary"
      variant={selected ? "filled" : "outlined"}
      onClick={onClick}
      onDelete={selected ? onDelete : undefined}
      deleteIcon={
        selected && isDeleting ? <CircularProgress size={16} /> : undefined
      }
    />
  );
}
